import { useTranslation } from 'react-i18next';
import { LuShield } from 'react-icons/lu';

import { ApplicantInsurances } from './ApplicantInsurances';
import { HeaderNotifications } from './HeaderNotifications';
import { BankCreditRequestFormSection } from '../BankCreditRequestFormSection';

type Props = {
    hasSecondApplicant: boolean;
    secondApplicantHidden: boolean;
};

export const ResidualDebtInsuranceSection: React.FC<Props> = ({ hasSecondApplicant, secondApplicantHidden }) => {
    const { t } = useTranslation();

    return (
        <BankCreditRequestFormSection
            title={t('BANK_CREDIT_REQUEST.RESIDUAL_DEBT_INSURANCE.TITLE')}
            headerNotification={<HeaderNotifications hasSecondApplicant={hasSecondApplicant} />}
            icon={<LuShield className="size-4" />}
            testId="residual-debt-insurance-section-header"
        >
            <div
                className="flex flex-col gap-4 border-t border-grey-light pt-3"
                data-testid="residual-debt-insurance-section"
            >
                <ApplicantInsurances isSecondApplicant={false} />
                {hasSecondApplicant && !secondApplicantHidden && <ApplicantInsurances isSecondApplicant />}
                {hasSecondApplicant && secondApplicantHidden && (
                    <span className="text-center text-sm text-grey">
                        {t('BANK_CREDIT_REQUEST.RESIDUAL_DEBT_INSURANCE.SECOND_APPLICANT_HIDDEN')}
                    </span>
                )}
            </div>
        </BankCreditRequestFormSection>
    );
};
